import { SpaceProps } from 'styled-system'

import Box from 'components/Box'
import SkeletonLoader from 'components/SkeletonLoader'

const SearchResultsLoader = ({ mt = '51px' }: SpaceProps) => {
  const tiles = []

  for (let i = 0; i < 3; i++) {
    tiles.push(
      <Box key={`search-loading-row-${i}`}>
        <SkeletonLoader width="170px" height="20px" mb="7px" borderRadius={2} />
        <SkeletonLoader width="333px" height="20px" mb="24px" borderRadius={2} />
      </Box>,
    )
  }

  return (
    <Box mt={mt} ml="20px">
      {tiles}
    </Box>
  )
}

export default SearchResultsLoader
